<div class="abstract body-m-bold" [innerHTML]="text | safeHtml"></div>
